import React, {Component} from 'react';
import * as Constants from './Constants';

class BreadCrumb extends Component {
    render() {
        return (
            <div>
                <div className="page-breadCrumb">
                    <a className="url_link" onClick={() => Constants.redirectToHome()}>Home</a>
                    <svg focusable="false" aria-hidden="true" className="icon">
                        <use xlink="http://www.w3.org/1999/xlink" href="#icon-chevron-right"></use>
                    </svg>
                    <a className="url_link active">{this.props.currentPage}</a>
                </div>
            </div>
        );
    }
}

export default BreadCrumb;
